import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import Footer from "./Footer";
import { useTranslation } from "../../i18n";

/**
 * Layout shell for unauthenticated / public pages.
 * Fixed header at top, footer at bottom, content in between.
 */
export default function PublicLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-surface-nav text-on-surface font-sans antialiased flex flex-col">
      <a
        href="#main-content"
        className="fixed left-3 top-3 z-[100] -translate-y-20 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-on-primary transition-transform focus:translate-y-0"
      >
        {t("layout.skipToContent")}
      </a>
      <PublicHeader />
      {/* pt-16 compensates for the fixed public header */}
      <main id="main-content" tabIndex={-1} className="flex-grow pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
